/* eslint-env es6 */
// TODO use es6 Map
export default function SafeKeyObject (obj = {}) {
    this.obj = obj;
    if (this.obj instanceof SafeKeyObject) {
        this.obj = $.extend(true, {}, this.obj.obj);
    } else {
        for (var k in this.obj) {
            this.obj[SafeKeyObject.safe(k)] = this.obj[k];
            delete this.obj[k];
        }
    }
}

SafeKeyObject.extend = function (dest) {
    if (!(dest instanceof SafeKeyObject)) {
        dest = new SafeKeyObject(dest);
    }
    var sources = _.toArray(arguments).slice(1);
    _.each(sources, function(source) {
        if (source) {
            if (source instanceof SafeKeyObject) {
                for (var safeProp in source.obj) {
                    dest.obj[safeProp] = source.obj[safeProp];
                }
            } else {
                for (var prop in source) {
                    dest.set(prop, source[prop]);
                }
            }
        }
    });
    return dest;
};
SafeKeyObject.safe = function (key) {
    return ' ' + key;
};
SafeKeyObject.prototype = {
    get: function (key) {
        return this.obj[SafeKeyObject.safe(key)];
    },
    set: function (key, value) {
        this.obj[SafeKeyObject.safe(key)] = value;
        return this;
    },
    unset: function (key) {
        delete this.obj[SafeKeyObject.safe(key)];
    },
    move: function (moveKey, targetKey, conditional, mapFun) {
        if (!conditional || this.has(moveKey)) {
            mapFun = mapFun || _.identity;
            this.set(targetKey, mapFun(this.get(moveKey)));
            this.unset(moveKey);
        }
    },
    decr: function (key, value) {
        if (value === undefined) {
            value = 1;
        }
        this.incr(key, -value);
    },
    incr: function (key, value) {
        if (value === undefined) {
            value = 1;
        }
        this.set(key, (this.get(key) || 0) + value);
    },
    extend: function () {
        SafeKeyObject.extend.apply(this, [this].concat(_.toArray(arguments)));
        return this;
    },
    each: function (iterator, context) {
        for (var k in this.obj) {
            if (context) {
                iterator = _.bind(iterator, context);
            }
            iterator(k.slice(1), this.obj[k]);
        }
        return this;
    },
    find: function (comparator, context) {
        for (var k in this.obj) {
            if (context) {
                comparator = _.bind(comparator, context);
            }
            if (comparator(k.slice(1), this.obj[k])) {
                return {
                    key: k.slice(1),
                    value: this.obj[k]
                };
            }
        }
        return {};
    },
    has: function (key) {
        return (SafeKeyObject.safe(key)) in this.obj;
    },
    length: function () {
        return _.size(this.obj);
    },
    values: function () {
        return _.values(this.obj);
    },
    entries: function () {
        var entries = [];
        for (var k in this.obj) {
            entries.push([k.slice(1), this.obj[k]]);
        }
        return entries;
    },
    isEmpty: function () {
        return $.isEmptyObject(this.obj);
    }
};



// WEBPACK FOOTER //
// ./app/src/lib/safekeyobject.es6